export default __webpack_public_path__ + "static/media/mobile-bg-2.a9fcb921.jpg";